export var ARG = {
    TELEFONICA: {
        name: 'TELEFONICA',
        list: [
            'ce33ec2e-94c1-4201-8ea4-ad290a001cac',
            '2c4dde69-9639-49d8-bcab-9564176a3900',
            '88f065ff-4ee7-4071-a664-5a29d896d7c6',
            '425a8e4b-aee3-4090-93da-4b7d4081807e'
        ]
    },
    OTHER: {
        name: 'OTHER'
    }
};
